/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mail_title-text[_ngcontent-%COMP%]{font-size:1.4rem;width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding-bottom:5px}.reject-tag[_ngcontent-%COMP%]{padding-bottom:8px;white-space:nowrap;color:var(--qoala-light-pink)}  .crown{display:inline-block;width:1.4em;height:1.1em;vertical-align:text-top}  .crown-no_best{background-color:var(--qoala-light-pink);mask:url(crown_no.fa22efc3343c2a5a52bb.svg) no-repeat center/contain;-webkit-mask:url(crown_no.fa22efc3343c2a5a52bb.svg) no-repeat center/contain}"];
export { styles as styles };
